module.exports = __webpack_public_path__ + "img/xtzdhhy.d099a1de.jpg";